export default {
  Title: 'Personality Assessment',
  Subtitle: 'Please answer every question honestly. Your responses will help us better understand your caregiving style.',
  ProgressText: '#{completed} of #{total} completed',
  AssessmentProgressTitle: 'Assessment Progress (#{completed}/#{total}):',
  SummaryTitle: 'Assessment Summary:',
  Questions: {
    patience_1: {
      Text: 'I stay calm even if someone repeats the same request many times.',
    },
    patience_2: {
      Text: 'When a situation becomes stressful, I can think clearly and act steadily.',
    },
    patience_3: {
      Text: 'I become restless if tasks take longer than I expected.',
    },
    adaptability_1: {
      Text: 'I adjust quickly when plans suddenly change.',
    },
    adaptability_2: {
      Text: 'I feel more comfortable when my day is predictable.',
    },
    adaptability_3: {
      Text: 'When something isn\'t working, I am quick to try a different approach.',
    },
    initiative_1: {
      Text: 'If I see a potential problem, I act before being asked.',
    },
    initiative_2: {
      Text: 'I prefer to wait for instructions before making changes.',
    },
    empathy_1: {
      Text: 'I can usually tell when someone is upset, even if they don\'t say so.',
    },
    empathy_2: {
      Text: 'I sometimes find it hard to understand why people are upset.',
    },
    empathy_3: {
      Text: 'Providing comfort to others is more important to me than finishing tasks quickly.',
    },
    communication_1: {
      Text: 'I am comfortable being very direct when explaining things.',
    },
    communication_2: {
      Text: 'I try to avoid conflict, even if it means not sharing my opinion.',
    },
    communication_3: {
      Text: 'I can stay calm even if someone disagrees strongly with me.',
    },
    resilience_1: {
      Text: 'After a hard day, I can usually recover quickly and return with energy.',
    },
    resilience_2: {
      Text: 'I sometimes dwell on difficult experiences for a long time.',
    },
    resilience_3: {
      Text: 'I enjoy following routines and set patterns in my work.',
    },
    resilience_4: {
      Text: 'I prefer days that bring variety and unexpected challenges.',
    },
    resilience_5: {
      Text: 'I like to carefully plan before acting, rather than making quick decisions.',
    },
    resilience_6: {
      Text: 'I feel most fulfilled when my work has an emotional impact, not just practical results.',
    },
  },
};
